import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  background-repeat: no-repeat;
  background-size: 100%;
`;
export const ContentBox = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
export const Content = styled.div`
  flex: 1;
  padding: 4rem;
  width: 100vw;

  h1 {
    font-size: 2.4rem;
    margin-bottom: 2.4rem;
  }

  ul.list {
    list-style: circle;
    padding-left: 25px;
    line-height: 25px;
  }

  @media (min-width: 700px) {
    h1 {
      font-size: 4rem;
    }

    padding: 4rem 8rem;
  }
`;

export const Terms = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;

  &::-webkit-scrollbar {
    width: 0.4rem;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.gray2};
    border-radius: 1rem;
  }

  a {
    color: ${({ theme }) => theme.colors.blueAccent};
    text-decoration: underline;
  }

  ul {
    list-style: disc;
  }

  ul,
  ol {
    padding-left: 20px;
  }
`;
